import styled from "styled-components/macro";

export const P = styled.p``;
